"use client";

import { c as _c } from "react/compiler-runtime";
import { useServices } from "../services-context";
import { useMemo } from "react";
import { ServiceDisplayMode } from "@/types/enums/service-display-mode";
import { getSidebarCategoryOptions } from "./category-sidebar-utils";
import { filterServices } from "./helpers";
import { isSyntheticPromotionCategoryName, withPromotionCategory } from "./promotion-category";
import { FIRST_AVAILABLE_PROVIDER_ID } from "@/stores/self-schedule-store";

/** Eligibility is independent of the visitor's search and category choices. */
export function useServiceFilterOptions() {
  const $ = _c(16);
  const {
    state: t0
  } = useServices();
  const {
    data,
    patientType,
    locationType,
    selectedLocation,
    selectedLocationId,
    selectedProviderId,
    selectedCategory
  } = t0;
  const locationId = selectedLocation?.id ?? selectedLocationId;
  const providerId = selectedProviderId === FIRST_AVAILABLE_PROVIDER_ID ? null : selectedProviderId;
  data?.services;
  data?.locations;
  const t1 = data?.services;
  const t2 = data?.locations;
  let t3;
  if ($[0] !== locationId || $[1] !== locationType || $[2] !== patientType || $[3] !== providerId || $[4] !== t1 || $[5] !== t2) {
    t3 = filterServices(t1, {
      searchQuery: "",
      selectedCategory: undefined,
      locations: t2,
      selectedLocationId: locationId,
      selectedProviderId: providerId,
      patientType,
      locationType
    });
    $[0] = locationId;
    $[1] = locationType;
    $[2] = patientType;
    $[3] = providerId;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const eligibleServices = t3;
  let t4;
  if ($[7] !== data?.categories || $[8] !== eligibleServices) {
    t4 = () => {
      const names = new Set(eligibleServices.map(_temp));
      return withPromotionCategory(data?.categories, eligibleServices).filter(category => names.has(category.name) || isSyntheticPromotionCategoryName(category.name, data?.categories));
    };
    $[7] = data?.categories;
    $[8] = eligibleServices;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  data?.categories;
  let t5;
  if ($[10] !== t4) {
    t5 = t4();
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const categories = t5;
  data?.serviceDisplayMode;
  data?.categories;
  let t6;
  bb0: {
    if (data?.serviceDisplayMode !== ServiceDisplayMode.CATEGORY_SIDEBAR) {
      t6 = new Set(categories.map(_temp2));
      break bb0;
    }
    t6 = new Set(getSidebarCategoryOptions(eligibleServices, data.categories).categoryNames);
  }
  const selectableCategoryNames = t6;
  const effectiveSelectedCategory = !selectedCategory || selectedCategory === "all" || !data || selectableCategoryNames.has(selectedCategory) ? selectedCategory : undefined;
  let t7;
  if ($[12] !== categories || $[13] !== effectiveSelectedCategory || $[14] !== eligibleServices) {
    t7 = {
      eligibleServices,
      categories,
      effectiveSelectedCategory
    };
    $[12] = categories;
    $[13] = effectiveSelectedCategory;
    $[14] = eligibleServices;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp2(category_0) {
  return category_0.name;
}
function _temp(service) {
  return service.category;
}